import React, { useState, useEffect } from 'react';
import { FontManager } from '@samuelmeuli/font-manager';
import Scrollbar from 'react-perfect-scrollbar';
import {
  Radio,
  RadioGroup,
  FormControl,
  FormControlLabel
} from '@material-ui/core';


const getFontId = (fontFamily) => fontFamily.replace(/\s+/g, '-').toLowerCase();

const FontPicker = (props) => {
  const {
    apiKey,
    activeFontFamily,
    pickerId,
    families,
    categories,
    scripts,
    variants,
    filter,
    limit,
    sort,
    onChange,
  } = props;

  const options = {
    pickerId,
    families,
    categories,
    scripts,
    variants,
    filter,
    limit,
    sort
  };

  const [loadingStatus, setLoadingStatus] = useState('loading');
  const [fonts, setFonts] = useState([]);
  const fontManager = new FontManager(apiKey, activeFontFamily, options, onChange);

  const initFontManager = async () => {
    try {
      await fontManager.init();
      setLoadingStatus('finished');
      const fontsCollection = Array.from(fontManager.getFonts().values())
        .map((font) => font.family === activeFontFamily
          ? {...font, variants: ['300', '400', '500', '600', '700']}
          : font
        );

      setFonts(fontsCollection);
    } catch (error) {
      setLoadingStatus('error');
      console.error('Error trying to fetch the list of available fonts');
      console.error(error);
    }
  };

  useEffect(() => {
    initFontManager();
  }, []);

  return (
    <div>
      {loadingStatus === 'finished' ?
        <FormControl component="div" className="border-1-light-grey max-h-250 min-h-250 p-4 w-full overflow-hidden">
          <Scrollbar
            options={{ suppressScrollX: true }}
          >
            <RadioGroup
              aria-label="scheme"
              name="scheme"
              value={activeFontFamily}
              onChange={(event) => {
                const {value} = event.target;
                const fontDetails = fonts.find((font) => font.family === value);
                onChange(value, fontDetails);
              }}
            >
              {fonts.map(
                (font) => {
                  const isActive = font.family === activeFontFamily;
                  const fontId = getFontId(font.family);
                  return (
                    <FormControlLabel
                      key={fontId}
                      value={font.family}
                      control={<Radio color="primary" size="small" />}
                      className="flex w-full"
                      label={
                        <div className="font-list-item">
                          <span
                            type="button"
                            id={`font-button-${fontId}${fontManager.selectorSuffix}`}
                            className={`font-button ${isActive ? 'active-font' : ''}`}
                          >
                            {font.family}
                          </span>
                        </div>
                      }
                    />
                  );
                },
              )}
            </RadioGroup>
          </Scrollbar>
        </FormControl>
        :
        <div />
      }
    </div>
  );
};

export default FontPicker;
